import styled from '@emotion/styled';

export const SectionContainer = styled.div`
  padding: 20px 0px;
`;

export const SectionTitle = styled.h2`
  font-weight: 600;
  font-size: 24px;
`;